/* unplugin-vue-components disabled */import { render } from "./KilaKilaCategoryCard.vue?vue&type=template&id=19157ad3&scoped=true"
import script from "./KilaKilaCategoryCard.vue?vue&type=script&lang=js"
export * from "./KilaKilaCategoryCard.vue?vue&type=script&lang=js"

import "./KilaKilaCategoryCard.vue?vue&type=style&index=0&id=19157ad3&scoped=true&lang=css"

import exportComponent from "E:\\Jweb\\结课作业\\KilaKila-Blog\\kilakila-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19157ad3"]])

export default __exports__